import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white rounded-t-3xl mx-4 md:mx-6 mt-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold mb-4">
              Stay Updated
            </h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-sm">
              Bookmark our site and check back weekly for the latest CSSBuy spreadsheet updates, new category additions, and fresh finds across all 14 categories.
            </p>
            <Link
              to="/cssbuy-spreadsheet-guide-2026"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-900 font-medium text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-white/70 uppercase tracking-wider mb-5">
              Popular Categories
            </h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-semibold text-white/70 uppercase tracking-wider mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  Main Store — CSSBuy Sheet
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  Buy It Now
                </a>
              </li>
              <li>
                <Link
                  to="/cssbuy-spreadsheet-guide-2026"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  Complete Guide 2026
                </Link>
              </li>
              <li>
                <a
                  href="#categories"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  All Categories
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-white/30 text-xs">CSSSpreadsheet.yachts</span>
          </div>

          <p className="text-white/30 text-xs text-center">
            &copy; {new Date().getFullYear()} CSSSpreadsheet. All rights reserved. Not affiliated with CSSBuy.
          </p>

          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-white/30 text-xs hover:text-white/50 transition-colors duration-200 underline decoration-white/10 hover:decoration-white/30"
            >
              Home
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-white/30 text-xs hover:text-white/50 transition-colors duration-200 underline decoration-white/10 hover:decoration-white/30"
            >
              Main Store
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}